import { Icon } from '@/shared/ui/Icon';
import { IconButton } from '@/shared/ui/IconButton';

import styles from './MetadataEditCard.module.css';

type MetadataEditCardProps = {
  title: string;
  renderBadgeList: () => React.ReactNode;
  handleEdit?: () => void;
  editable?: boolean;
  emptyText?: string;
};

const MetadataEditCard = ({
  title,
  renderBadgeList,
  handleEdit,
  editable = true,
  emptyText,
}: MetadataEditCardProps) => {
  const badgeList = renderBadgeList();
  const isEmpty = !badgeList;

  return (
    <div className={styles.metadataEditCard}>
      <div className={styles.titleCont}>
        <p className={styles.title}>{title}</p>
        {editable && handleEdit && (
          <IconButton onClick={handleEdit} tooltip={`${title} 편집`}>
            <Icon name="edit" size={16} />
          </IconButton>
        )}
      </div>
      {isEmpty && emptyText ? <span className={styles.emptyText}>{emptyText}</span> : badgeList}
    </div>
  );
};

export { MetadataEditCard };
export type { MetadataEditCardProps };
